import React from 'react'
import usePlayerState, { defaultState, UsePlayerState } from '../libs/usePlayerState'

export const PlayerStateContext = React.createContext<UsePlayerState>(defaultState)

const { Provider } = PlayerStateContext

const PageStateProvider = ({ children }) => {

  const playerState = usePlayerState()

  return <Provider value={playerState}>{ children }</Provider>

}

export default PageStateProvider
